module.exports = __webpack_public_path__ + "static/media/gal7.d02f31d3.jpg";